module.exports = __webpack_public_path__ + "img/guided-meditation.1a41a284.jpg";